import React from 'react';
/*import classnames from 'classnames';*/

export default class RequestReportRow extends React.PureComponent {
  /*constructor(props) {
    super(props);
  }*/

  render() {
    const RowData = this.props.RowData;
    let executeButton = null;
    let rejectButton = null;
    // console.log(RowData)
    if(RowData.CanExecute === false) {
      executeButton = <button key = {1} className="btn btn-sm btn-default" disabled>{RowData.Type === 'report_lost' ? 'Confirmed Lost' : 'Confirmed Broken'}</button>;
    } else if(RowData.Rejected) {
      rejectButton = <button key = {2} className="btn btn-sm btn-default" disabled>Report Rejected</button>;
    } else {
      if(RowData.Type === 'report_lost') {
        executeButton = <button key = {1} className="btn btn-sm btn-primary" 
                        onClick={()=>this.props.onReport(RowData.Alias)}>Confirm Lost</button>;
      } else {
        executeButton = <button key = {1} className="btn btn-sm btn-primary"
                        onClick={()=>this.props.onReport(RowData.Alias)}>Confirm Broken</button>;
      }
      rejectButton = <button key = {2} className="btn btn-sm btn-danger" onClick={()=>this.props.onReject(RowData.Alias)}>Reject</button>;
    }

    return (
      <tr>
        <td>{RowData.Asset.Name}</td>          
        <td>{RowData.Owner.FirstName}&nbsp;{RowData.Owner.LastName}</td>          
        <td>{RowData.Description}</td>      
        <td className="text-center">{[executeButton, ' ', rejectButton]}</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/request/helper/component/RequestReport/RequestReportRow.js